module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("Acknowledgments")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("This book, "), _c('em', [_vm._v("Avengers and Defenders: Glimpses of Chicago’s Jewish Past")]), _vm._v(" is a continuation of the anthology of my book, "), _c('em', [_vm._v("Looking Backward: Stories from Chicago’s Jewish Past,")]), _vm._v(" published in 2002. Like "), _c('em', [_vm._v("Looking Backward")]), _vm._v(" the stories contained in this book were first written for the quarterly, Chicago Jewish History, published by the Chicago Jewish Historical Society. The present book carries the title of "), _c('em', [_vm._v("Avengers and Defenders")]), _vm._v(" because the stories included in this book deal with people who fought for their rights whether in politics or business often with great success. The first story involves the Haymarket riot that occurred over one hundred twenty five years ago, and while it may not have Jews, it had a lasting impact on the Jewish community. Another story deals with Sholom Schwartzbard who came to Chicago to tell his story of revenge when he assassinated the Crimean “Butcher.” Then there is the story of Paley who defended Ed Murrow against McCarthy’s attacks. Martin Kamen’s story is included because he defended himself against libelous attacks by the Chicago Tribune who accused this Chicago scientist of being a Communist spy. He sued the "), _c('em', [_vm._v("Tribune")]), _vm._v(" and, against all odds, he won.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A number of stories deal with heroics in business ventures, and a number of others include persons of stature who achieved great success in law and academia. These are only a few examples of the brave avengers and defenders included in this volume.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("The book concludes with an addendum recording some of the messages I wrote for our quarterly concerning my personal views and experiences that occurred from 2003 to the present.")])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("My work relies heavily on the research sources of the Spertus Library, Newberry Library and Chicago History Museum.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Special thanks go to Bev Chubat, the editor of Chicago Jewish History Quarterly, who was of invaluable help in editing the original versions of my stories. I would like to thank Norman Schwartz, Adele Hast, Charles Bernstein, and Dan Sharon, members of our Society, for their research assistance, and Colleen Russell for her outstanding work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I extend my gratitude to Anita and Jordan Miller of Academy Chicago Publishers and to Sarah Olson for her first rate production of this book.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-698be582","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Acknowledgment.vue
// module id = 75
// module chunks = 0